import React, {FC} from 'react';
import {useComponent} from '../component-library';
import {ResponseLabels} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

interface YesNoToggleProps {
  id: string;
  questionTextId: string;
  value: YesNoValues;
  onChange?: (value: YesNoValues) => void;
  testId?: string;
  disabled?: boolean;
  responseLabels: ResponseLabels;
}

export enum YesNoValues {
  yes = 'yes',
  no = 'no',
}

export const YesNoToggle: FC<YesNoToggleProps> = React.memo(
  ({
    questionTextId,
    id,
    value,
    onChange,
    responseLabels,
    testId,
    disabled,
  }: YesNoToggleProps) => {
    const optionNo = {value: YesNoValues.no, label: responseLabels.no};
    const optionYes = {value: YesNoValues.yes, label: responseLabels.yes};
    const Toggle = useComponent('Toggle');
    return (
      <Toggle
        value={value}
        options={[optionNo, optionYes]}
        id={id}
        onChange={(newValue) => onChange?.(newValue as YesNoValues)}
        labelId={questionTextId}
        testId={testId}
        disabled={disabled}
      />
    );
  }
);

YesNoToggle.displayName = 'YesNoToggle';
